import { runOnPage } from './general.js';

runOnPage('guidelines-default', () => {
	document.addEventListener("DOMContentLoaded", () => {
		const sections = document.querySelectorAll("div[id]");
		const navLinks = document.querySelectorAll("nav a[href^='#']");
		const offset = 300;
		const scrollOffset = 70;

		function activateLink(id) {
			navLinks.forEach(link => {
				link.classList.toggle("active-link", link.getAttribute("href") === `#${id}`);
			});
		}

		function onScroll() {
			let currentId = "";
			sections.forEach(section => {
				const rect = section.getBoundingClientRect();
				if (rect.top <= offset && rect.bottom >= offset) {
					currentId = section.id;
				}
			});
			if (currentId) {
				activateLink(currentId);
			}
		}

		navLinks.forEach(link => {
			link.addEventListener("click", (e) => {
				e.preventDefault();
				const targetId = link.getAttribute("href").substring(1);
				const target = document.getElementById(targetId);
				if (target) {
					const top = target.getBoundingClientRect().top + window.pageYOffset - scrollOffset;
					window.scrollTo({ top, behavior: "smooth" });
				}
			});
		});

		window.addEventListener("scroll", onScroll);
		onScroll();

		const sideNav = document.getElementById('sideNav');
		const whiteSection = document.getElementById('white-section');

		function updateNavPosition() {
			if (!sideNav || !whiteSection) return;

			const navHeight = sideNav.offsetHeight;
			const sectionTop = whiteSection.offsetTop;
			const sectionHeight = whiteSection.offsetHeight;
			const sectionBottom = sectionTop + sectionHeight;

			const scrollY = window.scrollY;
			const fixedTop = (window.innerHeight - navHeight) / 2;
			const idealNavY = scrollY + fixedTop;

			const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
			const minLeft = 1 * rem;
			const maxLeft = 150 * rem;
			let computedLeft = ((window.innerWidth - 1000) / 2 - 250);
			computedLeft = Math.max(minLeft, Math.min(computedLeft, maxLeft));

			if (idealNavY <= sectionTop) {
				sideNav.style.position = 'absolute';
				sideNav.style.top = '0px';
				const whiteLeft = whiteSection.getBoundingClientRect().left;
				sideNav.style.left = `${computedLeft - whiteLeft}px`;
			} else if (idealNavY + navHeight >= sectionBottom) {
				sideNav.style.position = 'absolute';
				sideNav.style.top = `${sectionHeight - navHeight}px`;
				const whiteLeft = whiteSection.getBoundingClientRect().left;
				sideNav.style.left = `${computedLeft - whiteLeft}px`;
			} else {
				sideNav.style.position = 'fixed';
				sideNav.style.top = `${fixedTop}px`;
				sideNav.style.left = `${computedLeft}px`;
			}
		}

		window.addEventListener('scroll', () => requestAnimationFrame(updateNavPosition));
		window.addEventListener('resize', updateNavPosition);
		updateNavPosition();
	});
});
